import React, { createContext, useContext, useState, ReactNode } from 'react';

type DashboardView = 'dashboard' | 'analytics';

interface DashboardContextType {
  currentView: DashboardView;
  setCurrentView: (view: DashboardView) => void;
}

const DashboardContext = createContext<DashboardContextType | undefined>(undefined);

export const useDashboard = () => {
  const context = useContext(DashboardContext);
  if (context === undefined) {
    throw new Error('useDashboard must be used within a DashboardProvider');
  }
  return context;
};

interface DashboardProviderProps {
  children: ReactNode;
}

export const DashboardProvider: React.FC<DashboardProviderProps> = ({ children }) => {
  const [currentView, setCurrentView] = useState<DashboardView>('dashboard');

  return (
    <DashboardContext.Provider value={{
      currentView,
      setCurrentView
    }}>
      {children}
    </DashboardContext.Provider>
  );
};